module.exports = __webpack_public_path__ + "static/img/07056C_2_C_20210320_fit.7dd4f91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07056C_2_C_20210320_fit.png
// module id = VNrM
// module chunks = 0